export type BlogArticleProps = {
  id: string
  img: string
  title: string
  subtitle: string
  cta: string
  href: string
}

export const blogArticles:Array<BlogArticleProps> = [
  {
    id: 'core-web-bitals',
    img: require('@hydra/assets/img/articles/core-web-vitals.jpg'),
    title: 'home_card_cwv_title',
    subtitle: 'home_card_cwv_description',
    cta: 'home_card_cwv_cta',
    href: '/en/core-web-vitals/overview'
  },
  {
    id: 'google-analytics-4',
    img: require('@hydra/assets/img/articles/ga4.jpg'),
    title: 'home_card_ga4_title',
    subtitle: 'home_card_ga4_description',
    cta: 'home_card_ga4_cta',
    href: '/en/google-analytics-4'
  },
  {
    id: 'onpage-vs-offpage',
    img: require('@hydra/assets/img/articles/on-page-vs-off-page.png'),
    title: 'home_card_onpageoffpageseo_title',
    subtitle: 'home_card_onpageoffpageseo_description',
    cta: 'home_card_onpageoffpageseo_cta',
    href: '/en/blog/on-page-vs-off-page-seo-whats-the-difference'
  }
];

export default blogArticles;
